import { apiCall } from '../api/ServerApi';
import { callGETAndCache } from '../api/ServerCacheApi';
import { API_URL_PATHS } from '../consts/ApiUrlPaths';
import { INewView, IPropertyView, ISelectedViewResponse } from '../interfaces/PropertyViews';

import { logger } from './Logger';

const { PROPERTY_VIEWS_PATH, PROPERTIES_URL_PATH } = API_URL_PATHS;

export const getIssueTypesList = async (): Promise<string[]> => {
	return callGETAndCache('issue-types');
};

export const getViews = async (propertyId: string): Promise<IPropertyView[]> => {
	try {
		const url = `${PROPERTY_VIEWS_PATH}?propertyId=${propertyId}&transformOnlyMetadata=false`;
		return apiCall('GET', url);
	} catch (err) {
		logger.error('Failed to get Views from server', err);
		throw new Error(`Failed to get Views from server. Error ${err}`);
	}
};

export const createSelectedView = async (
	proeprtyId: string,
	viewId: string
): Promise<ISelectedViewResponse> => {
	const body = { viewId };
	try {
		const res: ISelectedViewResponse = await apiCall(
			'POST',
			`${PROPERTIES_URL_PATH}/${proeprtyId}/view-selection`,
			{ data: body }
		);
		return res;
	} catch (err) {
		logger.error('Failed to create selected View', err);
		throw new Error('Failed to create selected View');
	}
};

export const updateSelectedView = async (
	proeprtyId: string,
	viewId: string,
	id: string
): Promise<ISelectedViewResponse> => {
	const body = { proeprtyId, viewId, id };
	const res: ISelectedViewResponse = await apiCall(
		'PUT',
		`${PROPERTIES_URL_PATH}/${proeprtyId}/view-selection/${id}`,
		{
			data: body
		}
	);
	return res;
};

/**
 * @param propertyId
 * @returns:
 * Empty Array - No Selected was created ever
 * [{id, propertyId}] - No viewId (null) = All Content
 * [{id, viewId, propertyId}] - There's selected view
 */
export const getSelectedView = async (propertyId: string): Promise<ISelectedViewResponse[]> => {
	const res: ISelectedViewResponse[] = await apiCall(
		'GET',
		`${PROPERTIES_URL_PATH}/${propertyId}/view-selection`
	);
	return res;
};

export const deleteView = async (viewId: string): Promise<IPropertyView> => {
	return apiCall('DELETE', `${PROPERTY_VIEWS_PATH}/${viewId}`);
};

export const createView = async (view: INewView): Promise<IPropertyView> => {
	const res = await apiCall('POST', PROPERTY_VIEWS_PATH, { data: view });
	return res;
};

export const updateView = async (view: IPropertyView): Promise<IPropertyView> => {
	const res = await apiCall('PUT', `${PROPERTY_VIEWS_PATH}/${view.id}`, {
		data: view
	});
	return res;
};
